import { watch as O, nextTick as j, getCurrentScope as X, onScopeDispose as Y, unref as H, onMounted as k, getCurrentInstance as P, computed as x, ref as A, reactive as T } from "vue";
function z(e) {
  return X() ? (Y(e), !0) : !1;
}
function M(e) {
  return typeof e == "function" ? e() : H(e);
}
const I = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const K = Object.prototype.toString, V = (e) => K.call(e) === "[object Object]", B = () => {
};
function $(e) {
  return P();
}
function N(e, t = !0, o) {
  $() ? k(e, o) : t ? e() : j(e);
}
function te(e, t, o) {
  const s = O(e, (...f) => (j(() => s()), t(...f)), o);
  return s;
}
function S(e) {
  var t;
  const o = M(e);
  return (t = o == null ? void 0 : o.$el) != null ? t : o;
}
const m = I ? window : void 0;
function g(...e) {
  let t, o, s, f;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([o, s, f] = e, t = m) : [t, o, s, f] = e, !t)
    return B;
  Array.isArray(o) || (o = [o]), Array.isArray(s) || (s = [s]);
  const c = [], l = () => {
    c.forEach((r) => r()), c.length = 0;
  }, a = (r, n, i, d) => (r.addEventListener(n, i, d), () => r.removeEventListener(n, i, d)), p = O(
    () => [S(t), M(f)],
    ([r, n]) => {
      if (l(), !r)
        return;
      const i = V(n) ? { ...n } : n;
      c.push(
        ...o.flatMap((d) => s.map((h) => a(r, d, h, i)))
      );
    },
    { immediate: !0, flush: "post" }
  ), v = () => {
    p(), l();
  };
  return z(v), v;
}
function U(e) {
  return typeof e == "function" ? e : typeof e == "string" ? (t) => t.key === e : Array.isArray(e) ? (t) => e.includes(t.key) : () => !0;
}
function ne(...e) {
  let t, o, s = {};
  e.length === 3 ? (t = e[0], o = e[1], s = e[2]) : e.length === 2 ? typeof e[1] == "object" ? (t = !0, o = e[0], s = e[1]) : (t = e[0], o = e[1]) : (t = !0, o = e[0]);
  const {
    target: f = m,
    eventName: c = "keydown",
    passive: l = !1,
    dedupe: a = !1
  } = s, p = U(t);
  return g(f, c, (r) => {
    r.repeat && M(a) || p(r) && o(r);
  }, l);
}
function q() {
  const e = A(!1), t = P();
  return t && k(() => {
    e.value = !0;
  }, t), e;
}
function J(e) {
  const t = q();
  return x(() => (t.value, !!e()));
}
function Q(e, t, o = {}) {
  const { window: s = m, ...f } = o;
  let c;
  const l = J(() => s && "ResizeObserver" in s), a = () => {
    c && (c.disconnect(), c = void 0);
  }, p = x(() => Array.isArray(e) ? e.map((n) => S(n)) : [S(e)]), v = O(
    p,
    (n) => {
      if (a(), l.value && s) {
        c = new ResizeObserver(t);
        for (const i of n)
          i && c.observe(i, f);
      }
    },
    { immediate: !0, flush: "post" }
  ), r = () => {
    a(), v();
  };
  return z(r), {
    isSupported: l,
    stop: r
  };
}
function oe(e, t = { width: 0, height: 0 }, o = {}) {
  const { window: s = m, box: f = "content-box" } = o, c = x(() => {
    var n, i;
    return (i = (n = S(e)) == null ? void 0 : n.namespaceURI) == null ? void 0 : i.includes("svg");
  }), l = A(t.width), a = A(t.height), { stop: p } = Q(
    e,
    ([n]) => {
      const i = f === "border-box" ? n.borderBoxSize : f === "content-box" ? n.contentBoxSize : n.devicePixelContentBoxSize;
      if (s && c.value) {
        const d = S(e);
        if (d) {
          const h = d.getBoundingClientRect();
          l.value = h.width, a.value = h.height;
        }
      } else if (i) {
        const d = Array.isArray(i) ? i : [i];
        l.value = d.reduce((h, { inlineSize: w }) => h + w, 0), a.value = d.reduce((h, { blockSize: w }) => h + w, 0);
      } else
        l.value = n.contentRect.width, a.value = n.contentRect.height;
    },
    o
  );
  N(() => {
    const n = S(e);
    n && (l.value = "offsetWidth" in n ? n.offsetWidth : t.width, a.value = "offsetHeight" in n ? n.offsetHeight : t.height);
  });
  const v = O(
    () => S(e),
    (n) => {
      l.value = n ? t.width : 0, a.value = n ? t.height : 0;
    }
  );
  function r() {
    p(), v();
  }
  return {
    width: l,
    height: a,
    stop: r
  };
}
function se(e, t = {}) {
  const {
    threshold: o = 50,
    onSwipe: s,
    onSwipeEnd: f,
    onSwipeStart: c,
    passive: l = !0,
    window: a = m
  } = t, p = T({ x: 0, y: 0 }), v = T({ x: 0, y: 0 }), r = x(() => p.x - v.x), n = x(() => p.y - v.y), { max: i, abs: d } = Math, h = x(() => i(d(r.value), d(n.value)) >= o), w = A(!1), R = x(() => h.value ? d(r.value) > d(n.value) ? r.value > 0 ? "left" : "right" : n.value > 0 ? "up" : "down" : "none"), W = (u) => [u.touches[0].clientX, u.touches[0].clientY], _ = (u, y) => {
    p.x = u, p.y = y;
  }, L = (u, y) => {
    v.x = u, v.y = y;
  };
  let b;
  const C = Z(a == null ? void 0 : a.document);
  l ? b = C ? { passive: !0 } : { capture: !1 } : b = C ? { passive: !1, capture: !0 } : { capture: !0 };
  const D = (u) => {
    w.value && (f == null || f(u, R.value)), w.value = !1;
  }, G = [
    g(e, "touchstart", (u) => {
      if (u.touches.length !== 1)
        return;
      b.capture && !b.passive && u.preventDefault();
      const [y, E] = W(u);
      _(y, E), L(y, E), c == null || c(u);
    }, b),
    g(e, "touchmove", (u) => {
      if (u.touches.length !== 1)
        return;
      const [y, E] = W(u);
      L(y, E), !w.value && h.value && (w.value = !0), w.value && (s == null || s(u));
    }, b),
    g(e, ["touchend", "touchcancel"], D, b)
  ];
  return {
    isPassiveEventSupported: C,
    isSwiping: w,
    direction: R,
    coordsStart: p,
    coordsEnd: v,
    lengthX: r,
    lengthY: n,
    stop: () => G.forEach((u) => u())
  };
}
function Z(e) {
  if (!e)
    return !1;
  let t = !1;
  const o = {
    get passive() {
      return t = !0, !1;
    }
  };
  return e.addEventListener("x", B, o), e.removeEventListener("x", B), t;
}
export {
  g as a,
  se as b,
  ne as o,
  oe as u,
  te as w
};
//# sourceMappingURL=index.72N0HVaZ.js.map
